export enum RuleTypeDefinition {
  FOLDER = 'dossier',
  INPUT = 'input',
  INPUT_DATE = 'input_date',
  SELECT = 'select',
  STATE = 'state',
}
